/* eslint-disable */
import gsap from 'gsap';
import successPageAnimate from '../js/animate-in.js';

export default {
  init() {
    // JavaScript to be fired on all pages

    // Twitter
    let twitterShare = Array.from(document.querySelectorAll('.share-twitter'));
    twitterShare.forEach(tweet => {
      tweet.addEventListener('click', (event) => {
        event.preventDefault();

        window.open('https://twitter.com/intent/tweet?status=&url=' + event.target.href, 'newwindow', 'width=600,height=400');
      })
    })

    // Mail
    let mailShare = Array.from(document.querySelectorAll('.share-email'));
    mailShare.forEach(mail => {
      mail.addEventListener('click', event => {
        event.preventDefault();

        // location.href = 'mailto:?&subject='+document.title+'&body='+window.location.href;
        // window.open('mailto:?&subject='+document.title+'&body='+window.location.href, 'newwindow', 'width=600,height=400');
        window.open('mailto:?&subject='+document.title+'&body='+window.location.href, '_blank');
      })
    })

    let linkShare = document.querySelectorAll('.share-link');
    linkShare.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        copy(event);
      });
    })

    /* eslint-disable */
    function copy(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        // var input = event.target.nextElementSibling;

        const el = document.createElement('textarea');  // Create a <textarea> element
        el.value = window.location.href;                                 // Set its value to the string that you want copied
        el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
        el.style.position = 'absolute';
        el.style.left = '-9999px';                      // Move outside the screen to make it invisible
        document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
        const selected =
          document.getSelection().rangeCount > 0        // Check if there is any content selected previously
            ? document.getSelection().getRangeAt(0)     // Store selection if found
            : false;                                    // Mark as false to know no selection existed before
        el.select();                                    // Select the <textarea> content
        document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
        document.body.removeChild(el);                  // Remove the <textarea> element
        if (selected) {                                 // If a selection existed before copying
          document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
          document.getSelection().addRange(selected);   // Restore the original selection
        }
        event.target.nextElementSibling.classList.add('active');
          console.log(event.target.nextElementSibling)

          setTimeout(() => {
            event.target.nextElementSibling.classList.remove('active');
          }, 1500)
      }



    window.fbAsyncInit = function () {
      // eslint-disable-next-line
      FB.init({
        appId: '2694891214062349',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v8.0',
      });
    };


    function FacebookShare(event) {
      event.preventDefault();
      // event.stopImmediatePropagation()

      let shareUrl = window.location.href;

      console.log(shareUrl)

      // eslint-disable-next-line
      FB.ui({
        method: 'share',
        // href: 'https://developers.facebook.com/docs/'
        href: shareUrl,
      },
        // callback
        function (response) {
          if (response && !response.error_message) {
            // eslint-disable-next-line
            console.log('Posting completed.');
          } else {
            // eslint-disable-next-line
            console.log('Error while posting.');
          }
        }
      );
    }

    let fb = document.querySelectorAll('.share-fb');
    fb.forEach(fb => {
      fb.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation()
        FacebookShare(event)
      });
    })


    if (document.body.classList.contains('error404')) {
      const firstLoadAni = () => {

        setTimeout( () => {
          gsap.to( '#bgFadeIn' , 0.4 , {
            opacity: 1,
            ease: 'power1.in',
          })

          setTimeout( () => {
            gsap.to( '.app-wrapper' , 0.5 , {
              opacity: 1,
              ease: 'power1.in',
            })
            successPageAnimate('four-o-four-heading');
          },350);

        },0);
      }

      firstLoadAni();
    }

    // PNG instead of the WEBP holographic Image
    if (document.body.classList.contains('home') ||
        document.body.classList.contains('thank-you') ||
        document.body.classList.contains('page-template-template-signup') ||
        document.body.classList.contains('page-template-template-isfor')
        ) {

      if(navigator.userAgent.toLowerCase().indexOf('safari/') > -1) {
        var $bgEl =  document.getElementById('bgFadeIn');
        $bgEl.classList.add('safari-browser');
      }
    }


    if(navigator.userAgent.toLowerCase().indexOf('safari/') > -1) {

      // reloads page for safari - since it tried to use it's cahce instead...
      window.onpageshow = function(event) {
        if (event.persisted) {
          window.location.reload();
        }
      }
    }

  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js